import { Box, CssBaseline, Toolbar } from '@mui/material';
import Sidebar from './SideBar';
import Header from './Header';

export default function AppLayout({ children, collapse }) {
  return (
    <>
      <CssBaseline />
      {/* Header collé en haut */}
      <Header />

      <Box sx={{ display: 'flex' }}>
        {/* Sidebar fixe à gauche */}
        <Sidebar {...{collapse}} />

        {/* Contenu principal à droite */}
        <Box component="main" sx={{ flexGrow: 1, overflowX:'scroll' }}>
          {children}
        </Box>
      </Box>
    </>
  );
}
